class Accordion {
    init() {
        this.initAccordion();
    }

    initAccordion() {
        let accordionTitle = document.querySelectorAll('.accordion-item-title');

        accordionTitle.forEach(title => {
            title.addEventListener('click', (event) => {
                event.target.parentNode.classList.toggle('accordion-item--active');
            });
        });
    }
}

export default Accordion;

(() => {
    const accordion = new Accordion();
    accordion.init();
})();